module.exports = __webpack_public_path__ + "img/8.32d2be13.jpg";